import TableLayout from "../layout/TableLayout";
import UserInfoCell from "../common/UserInfoCell";
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  NoRecordsFound,
} from "../Table";

import Button from "../ui/Button";
import { downloadHealthCheckDocument} from "../../services/labourLaw";
import DownloadIcon from "@mui/icons-material/Download";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

const ComplianceIcon = ({ value }) =>
  value ? (
    <span className="text-success fw-bold">✔</span>
  ) : (
    <span className="text-danger fw-bold">✖</span>
  );

const handleDownloadDocument = async (fileName, documentName) => {
  try {
    const response = await downloadHealthCheckDocument(fileName);

    if (response?.status === 200) {
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);

      const ext = fileName.split(".").pop();
      const a = document.createElement("a");

      a.href = url;
      a.download = `${documentName || "document"}.${ext}`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      setTimeout(() => URL.revokeObjectURL(url), 100);
    } else {
      toast.error("Failed to download document. Please try again.");
    }
  } catch (error) {
    toast.error(
      error.response?.data?.message ||
        "An error occurred while downloading the document"
    );
    console.error("Download Document Error:", error);
  }
};


const LabourLawList = ({ users = [], onHealthCheckAction = () => {} }) => {
  return (
    <TableLayout className="mt-3">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Employee Name (Code)</TableHead>
            <TableHead className="text-center">Timely Wages</TableHead>
            <TableHead className="text-center">Health Check</TableHead>
            <TableHead className="text-center">PF</TableHead>
            <TableHead className="text-center">ESIC</TableHead>
            <TableHead className="text-center">Shift Hours</TableHead>
            <TableHead className="text-center">Overtime</TableHead>
            <TableHead className="text-center">Basic CTC</TableHead>
            <TableHead className="text-center">Skill Level Wages</TableHead>
            <TableHead className="text-center">Action</TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {users.length ? (
            users.map((u) => (
              <TableRow key={u.userId}>
                {/* Employee */}
                <TableCell>
                  <UserInfoCell
                    name={u.name}
                    employeeId={u.employeeCode}
                    token={u.token}
                  />
                </TableCell>

                {/* Compliance Indicators */}
                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.timelyWages} />
                </TableCell>

                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.healthCheck} />
                </TableCell>

                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.pf} />
                </TableCell>

                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.esic} />
                </TableCell>

                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.shiftHours} />
                </TableCell>

                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.overtime} />
                </TableCell>

                {/* Basic CTC */}
                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.basic_ctc} />
                </TableCell>

                {/* Skill Level */}
                <TableCell className="text-center">
                  <ComplianceIcon value={u.compliance?.skill_level} />
                </TableCell>

                {/* Action */}
                <TableCell className="text-center">
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    
                    {/* Add / Update Health Details Button */}
                    <Button
                      size="xs"
                      className="p-1"
                      variant={u.compliance?.healthCheck ? "dark" : "success"}
                      onClick={() => onHealthCheckAction(u)}
                    >
                      <span className="d-flex align-items-center text-white gap-1 text-xs">
                        {u.compliance?.healthCheck ? (
                          <>
                            <EditIcon sx={{ fontSize: 14 }} />
                            <span>Health Details</span>
                          </>
                        ) : (
                          <>
                            <AddIcon sx={{ fontSize: 14 }} />
                            <span>Health Details</span>
                          </>
                        )}
                      </span>
                    </Button>

                    {/* Download icon placeholder (freezes alignment) */}
                    <div style={{ width: 20, height: 20 }}>
                      {u.compliance?.healthCheckDoc && (
                        <Tooltip title="Download Document" placement="top" arrow>
                          <DownloadIcon
                            className="cursor-pointer"
                            sx={{ fontSize: 25 }}
                            onClick={() =>
                              handleDownloadDocument(
                                u.compliance.healthCheckDoc,
                                `${u.employeeCode}_Health_Document`
                              )
                            }
                          />
                        </Tooltip>
                      )}
                    </div>

                  </div>
                </TableCell>

              </TableRow>
            ))
          ) : (
            <NoRecordsFound colSpan={8} />
          )}
        </TableBody>
      </Table>
    </TableLayout>
  );
};

export default LabourLawList; 
